__turbopack_context__.v({
  "ChannelTextWrapper": "channelherocard-module-scss-module__QvURna__ChannelTextWrapper",
  "audioIconWrapper": "channelherocard-module-scss-module__QvURna__audioIconWrapper",
  "channelWrapper": "channelherocard-module-scss-module__QvURna__channelWrapper",
  "mobileAlbum": "channelherocard-module-scss-module__QvURna__mobileAlbum",
});
